(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function heroFor(el) {
    var id = el && el.getAttribute('data-section');
    return (id && document.getElementById('sbt-' + id)) || document.querySelector('[data-sbt-hero]');
  }
  function setTotals(text) {
    document.querySelectorAll('[data-sbt-total]').forEach(function (n) { n.textContent = text; });
  }
  // delegacja na dokumencie: elementy sekcji mogą jeszcze nie istnieć
  document.addEventListener('change', function (e) {
    var r = e.target.closest && e.target.closest('[data-sbt-qty]');
    if (!r) return;
    setTotals(r.getAttribute('data-total'));
    document.querySelectorAll('[data-sbt-sticky-note]').forEach(function (n) { n.textContent = r.getAttribute('data-label'); });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sbt-add]');
    if (!b) return;
    e.preventDefault();
    var hero = heroFor(b);
    if (!hero) return;
    var q = hero.querySelector('[data-sbt-qty]:checked');
    var qty = q ? parseInt(q.value, 10) : 1;
    var err = hero.querySelector('[data-sbt-error]');
    b.disabled = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(hero.getAttribute('data-variant'), 10), quantity: qty }] })
    }).then(function (res) {
      if (!res.ok) throw new Error('add');
      window.location.href = root + 'cart';
    }).catch(function () {
      b.disabled = false;
      if (err) err.textContent = 'Nie udało się dodać do koszyka. Spróbuj jeszcze raz.';
    });
  });
  document.addEventListener('click', function (e) {
    var u = e.target.closest && e.target.closest('[data-sbt-upsell]');
    if (!u) return;
    e.preventDefault();
    u.disabled = true;
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(u.getAttribute('data-line'), 10), quantity: parseInt(u.getAttribute('data-qty'), 10) })
    }).then(function () { window.location.reload(); }).catch(function () { u.disabled = false; });
  });
  // sticky pasek: pokazuj, gdy przycisk w hero zniknie z ekranu
  function initSticky() {
    var bar = document.querySelector('[data-sbt-sticky]');
    var btn = document.querySelector('[data-sbt-hero] [data-sbt-add]');
    if (!bar || !btn || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
    }).observe(btn);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky); else initSticky();
  // kropki karuzeli w hero, ograniczone do sekcji
  document.querySelectorAll('[data-sbt-hero]').forEach(function (hero) {
    var track = hero.querySelector('.sbt-track'), dots = hero.querySelectorAll('.sbt-hero__dots span');
    if (!track || !dots.length) return;
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (d, k) { d.style.background = k === i ? '#C2571A' : ''; });
    }, { passive: true });
  });
})();
